import React, { useEffect, useState } from "react";
import { Header, Button } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import Wordcloud from "../components/Wordcloud";
import KeywordFrequencyTable from "../components/KeywordFrequencyTable";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from 'html2canvas'; // 추가

const VisualizeWordcloudEdit = () => {
  const { currentColor } = useStateContext();
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  
  const navigate = useNavigate();
  const location = useLocation();

  // 키워드별 색상 상태 관리 (상위 페이지에서 받은 상태로 초기화)
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});
  const [intentName, setIntentName] = useState(location.state?.intentName || "");
  // const [intentDetailName, setIntentDetailName] = useState(location.state?.intentDetailName || "");
  const [sentiment, setSentiment] = useState(location.state?.sentiment || "");


  const downloadChartAsImage = async (chartId, fileName) => {
    const chartElement = document.getElementById(chartId); // 캡처할 차트의 DOM 요소
    if (!chartElement) {
      console.error(`Element with ID ${chartId} not found`);
      return;
    }

    try {
      const canvas = await html2canvas(chartElement, { scale: 2 }); // 캔버스로 렌더링
      const link = document.createElement('a');
      link.download = `${fileName}.png`; // 파일 이름
      link.href = canvas.toDataURL('image/png'); // 캡처된 이미지를 PNG로 변환
      link.click(); // 다운로드 실행
    } catch (error) {
      console.error('Error capturing chart:', error);
    }
  };

  // 색상 변경 핸들러
  const handleColorChange = (keyword, color) => {
    setKeywordColors((prevColors) => ({
      ...prevColors,
      [keyword]: color, // 특정 키워드에 색상 적용
    }));
  };

  // 이전 페이지로 돌아가기
  const goBack = () => {
    console.log("이전 페이지 이동 버튼 클릭");
    navigate("/vis/wordcloud-detail", 
      { state: { intentName, sentiment, keywordColors } }); // 변경된 색상 상태 전달
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, [])

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <div className="flex gap-3 items-center">
      <Button
        color="white"
        bgColor={currentColor}
        text="이전 페이지"
        borderRadius="10px"
        onClick={goBack}
      />
      <Button
          color="white"
          bgColor={currentColor}
          text="이미지 다운로드(.png)"
          borderRadius="10px"
          onClick={() => downloadChartAsImage(`wordcloud-container-${sentiment}`,
            `워드클라우드_${intentName}_${sentiment}`)} // 다운로드 핸들러
        />

        </div>
      <br/>
      <div className="flex gap-5">
        <Header
          title= {`워드클라우드 편집 페이지`}
        />
        
      </div>
        <p className="text-m font-semibold">*토픽분류: {intentName}</p>
        {/* <p className="text-m font-semibold">*의도(소분류): {intentDetailName}</p> */}
        <p className="text-m font-semibold">*감정분류: {sentiment}</p>
        <br/>

      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        <div className="flex">
          <div className="flex-[6]" id={`wordcloud-container-${sentiment}`}>
          <Wordcloud sentiment={sentiment} intentName={intentName}
                     pageType={"전체"} keywordColors={keywordColors} />
          </div>
          <div className="flex-[4]">
            <KeywordFrequencyTable
              sentiment={sentiment} intent={intentName}
              keywordColors={keywordColors} // 색상 정보 전달
              onColorChange={handleColorChange} // 색상 변경 핸들러 전달
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualizeWordcloudEdit;
